module.exports = __webpack_public_path__ + "img/oneRed.1707ecc9.jpg";